import angular from 'angular'
import template from './template.html'

export class NominasNominaColaboradoresListaRemuneradosEliminarComponent {
  data
  onClose
  procesando = false

  constructor (NominasNominaColaboradoresColaborador) {
    this.NominasNominaColaboradoresColaborador = NominasNominaColaboradoresColaborador
  }

  aceptar () {
    this.procesando = true

    this.NominasNominaColaboradoresColaborador.delete(this.data.id_nomina, this.data.id_empresa, this.data.id_empleado)
      .then(() => (this.cerrar(this.data)))
      .finally(() => (this.procesando = false))
  }

  cerrar (data) {
    this.onClose({$event: {data: data}})
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresListaRemuneradosEliminar', {
    template: template,
    controller: NominasNominaColaboradoresListaRemuneradosEliminarComponent,
    bindings: {
      data: '<',
      onClose: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/lista/remunerados/eliminar/component.js